export function dateFormating(deadline = "") {
  const date = new Date(deadline);
  const options = { day: "numeric", month: "long" };
  const formattedDate = date.toLocaleDateString("en-US", options);
  const [day, month] = formattedDate.split(" ");
  return { day, month };
}
